module.exports = __webpack_public_path__ + "wordmark.d113c385.svg";